import React from 'react';
import { useNavigate } from 'react-router-dom';
import { theme } from '../styles/theme';

function Header() {
  const navigate = useNavigate();
  return (
    <div style={styles.header}>
      <div onClick={() => navigate('/admin/dashboard')} style={{ cursor: 'pointer' }}>
        <img
          src={`${process.env.REACT_APP_ASSETS_URL}/logo.png`}
          alt="Ceramichine Logo"
          style={styles.logo}
        />
      </div>
    </div>
  );
}

const styles = {
  header: {
    backgroundColor: theme.colors.white,
    padding: '0px',
    boxShadow: theme.shadows.main,
    marginBottom: '20px',
    borderRadius: theme.borderRadius,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    maxWidth: '1000px',
  },
  logo: {
    height: '50px',
    objectFit: 'contain',
  },
};

export default Header;
